import type { PartialParking } from '@repo/domain';

/** Whether the search delivered the parking's borders or its entrance, which are then drawn instead of its pin. */
export const hasParkingShapes = (parking: PartialParking): boolean =>
  parking.paths.length > 0 || parking.entrance !== undefined;
